import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import AboutUsMidContent from './AboutUsMidContent';

function About() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  return (
    <div className="boxed_wrapper ltr">
      {/* Preloader */}
      {isLoading && (
        <div className="loader-wrap">
          <div className="preloader">
            <div className="preloader-close">close</div>
            <div id="handle-preloader" className="handle-preloader">
              <div className="animation-preloader">
                <div className="txt-loading">
                  <img src="assets/images/animation_logo.gif" alt="Loading animation" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Search Popup */}
      <div id="search-popup" className="search-popup">
        <div className="popup-inner">
          <div className="upper-box">
            <figure className="logo-box">
              <Link to="/">
                <img src="assets/images/logo-2.png" alt="Ravline Corp Logo" />
              </Link>
            </figure>
            <div className="close-search">
              <span className="fas fa-times"></span>
            </div>
          </div>
          <div className="overlay-layer"></div>
          <div className="auto-container">
            <div className="search-form">
              <form method="post" action="index.html">
                <div className="form-group">
                  <fieldset>
                    <input
                      type="search"
                      className="form-control"
                      name="search-input"
                      placeholder="Search for services or resources"
                      required
                    />
                    <button type="submit">
                      <i className="fas fa-search"></i>
                    </button>
                  </fieldset>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Header />

      {/* Page Title */}
      <section className="page-title">
        <div className="bg-layer" style={{ backgroundImage: `url('assets/images/background/page-title.jpg')` }}></div>
        <div className="line-grid-wrap">
          <span className="line-grid-1"></span>
          <span className="line-grid-2"></span>
          <span className="line-grid-3"></span>
          <span className="line-grid-4"></span>
          <span className="line-grid-5"></span>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>About Ravline Corp</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>About</li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Title End */}

      {/* About Section */}
      <section className="pt_70 pb_30">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 content-column">
              <div className="content_block_three">
                <div className="content-box">
                  <div className="sec-title mb_25">
                    <span className="sub-title mb_14">Welcome to Ravline Corp</span>
                    <h2>Empowering Wealth with Purpose</h2>
                  </div>
                  <div className="text-box">
                    <p>
                    </p>
                    <p>
                    Ravline Corp, founded in November 2019 and based in South Florida, is a premier business consulting and financial solutions firm dedicated to <strong>empowering entrepreneurs, individuals, and small businesses to build wealth with purpose</strong>. We specialize in strategic business development, credit and capital readiness, insurance planning, and real estate advisory.

                    <br />
                    <br />

                      Led by Luneida V. Augustin, CEO and licensed real estate agent at First World Realty, and Rodney C. Rutty, CFO and NMLS #1058549, our team brings unparalleled expertise in wealth consulting, business credit, lending strategies, and insurance planning, including Life, Health, and Annuity solutions. Whether you're launching a business, restructuring for growth, planning for retirement, or navigating complex financial challenges, Ravline Corp provides customized, structured financial solutions to move you forward.
                    </p>
                    <p>
                      <strong>We don't just consult — we partner with your success.</strong>
                    </p>
                    <div className="btn-box mt_20">
                      <Link to="/contact" className="theme-btn btn-one">
                        Get Started Today
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section End */}

      {/* Vision & Mission Section */}
      <section className="pt_70 pb_30">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box mb_30">
                <div className="sec-title">
                  <span className="sub-title mb_16">Our Vision</span>
                </div>
                <div className="text-box">
                  <p>
                    To be the leading provider of innovative financial solutions that empower entrepreneurs, individuals, and businesses to achieve lasting wealth and success.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 content-column">
              <div className="content-box mb_30">
                <div className="sec-title">
                  <span className="sub-title mb_16">Our Mission</span>
                </div>
                <div className="text-box">
                  <p>
                    To guide our clients through their financial journeys with expert advice, tailored services, and a commitment to their long-term success, ensuring they have the tools and knowledge to thrive.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Vision & Mission End */}

      {/* Team and Technology Partnership Section */}
      <AboutUsMidContent />

      <Footer />

      {/* Scroll to Top */}
      <div
        className="scroll-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        style={{ cursor: 'pointer' }}
      >
        <div>
          <div className="scroll-top-inner">
            <div className="scroll-bar">
              <div className="bar-inner"></div>
            </div>
            <div className="scroll-bar-text">Go To Top</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;